/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_ForbiddenInputs */



/**
* | output |
* | --- |
* | "You do not have permission to use this model or chat." |
*
* @param {Chat_Error_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_forbidden = /** @type {((inputs?: Chat_Error_ForbiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_ForbiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du hast keine Berechtigung, dieses Modell oder diesen Chat zu verwenden.")
	return /** @type {LocalizedString} */ ("You do not have permission to use this model or chat.")
});